import SchemaService from "./services/schema.service";
import AppManager from "./app-manager/app-manager.component";

angular
  .module('schema', [])
  .service('SchemaService', SchemaService)
  .component('appManager', AppManager);